module.exports = __webpack_public_path__ + "static/media/analytics-icon.3f4943dd.svg";